export default __webpack_public_path__ + "static/marek-polacek-884e0e3d17770d2525e0e597680fe4ce.jpg";